// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconArrowsLinkLeft_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s8IconSvg = html `<svg viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M3.64359 7.35359L0.290039 4.00004L3.64359 0.646484L4.3507 1.35359L2.20425 3.50004H7.99715V4.50004H2.20425L4.3507 6.64648L3.64359 7.35359Z" class="svg-bg"/>
</svg>
`;
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.96997 11.5288L0.439919 5.99877L5.96997 0.468726L7.03057 1.52933L3.31109 5.24881H12V6.74874H3.31109L7.03057 10.4682L5.96997 11.5288Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.29707 14.7072L0.589966 8.00008L7.29707 1.29297L8.71129 2.70718L4.41839 7.00008H15.9999V9.00008H4.41839L8.71129 13.293L7.29707 14.7072Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M11.2928 20.6072L9.87866 22.0214L0 12.0717L9.87878 2.05078L11.293 3.46497L3.52164 11.0717H24V13.0717H3.53015L11.2928 20.6072Z" class="svg-bg"/>
</svg>
`;
/**
 * IconArrowsLinkLeft is a generated icon component.
 */
let IconArrowsLinkLeft = IconArrowsLinkLeft_1 = class IconArrowsLinkLeft extends IconBaseElement {
    render() {
        return html `${IconArrowsLinkLeft_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconArrowsLinkLeft.icons = new Map([
    ['s8', _s8IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconArrowsLinkLeft = IconArrowsLinkLeft_1 = __decorate([
    customElement('zui-icon-arrows-link-left')
], IconArrowsLinkLeft);
export { IconArrowsLinkLeft };
